import { ChunkErrorBoundary, Spinner } from "@cheatsheetz/core-ui";
import { HomeRoutes } from "@cheatsheetz/sheetz-home/routes";
import { Suspense, useState } from "react";
import { Outlet } from "react-router-dom";
import { BrandIcon } from "@/components/BrandIcon";
import { Footer } from "./Footer";
import { NavLink } from "./NavItem";
import { NavigationMenu } from "./NavigationMenu";
import { NavigationProgress } from "./NavigationProgress";
import { OutdatedBanner } from "./OutdatedBanner";
import { useScrollDirection } from "./useScrollDirection";

export function RootLayout() {
  const scrollDirection = useScrollDirection();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const shouldHide = scrollDirection === "down" && !mobileMenuOpen;

  return (
    <div className="flex min-h-screen flex-col">
      <header
        className={`relative sticky top-0 z-50 border-b border-border bg-navbar text-navbar-fg transition-transform duration-300 ${
          shouldHide ? "md:translate-y-0 -translate-y-full" : "translate-y-0"
        }`}
      >
        <div className="mx-auto flex h-14 max-w-7xl items-center justify-between px-4">
          <NavLink
            to={HomeRoutes.Home}
            intent="plain"
            className="text-lg font-semibold tracking-tight"
          >
            <BrandIcon className="size-6" />
            Cheet.io
          </NavLink>
          <NavigationMenu onMobileMenuOpenChange={setMobileMenuOpen} />
        </div>
        <NavigationProgress />
      </header>
      <OutdatedBanner />
      <main className="flex flex-1 flex-col">
        <ChunkErrorBoundary>
          <Suspense
            fallback={
              <div className="flex flex-1 items-center justify-center py-20">
                <Spinner size="lg" />
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </ChunkErrorBoundary>
      </main>
      <Footer />
    </div>
  );
}
